export default __webpack_public_path__ + "static/media/14-100.6e058317.jpg";